/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：413__part-6
 */

"use strict"

import /* [auto-meaningful-name] */Color from /* 51 */"color"
import * as /* [auto-meaningful-name] */Module_10 from /* 10 */"../../../10/index"
import * as /* [auto-meaningful-name] */Module_76 from /* 76 */"../../../76"
import * as /* [auto-meaningful-name] */Module_290 from /* 290 */"../../../290"
import /* [auto-meaningful-name] */Module_2901 from /* 290 */"../../../290"
import * as /* [auto-meaningful-name] */Module_95 from /* 95 */"../../../95"
import * as /* [auto-meaningful-name] */Module_428 from /* 428 */"../index"
function Z(e, t) {
  try {
    return Color(e.toString()).alpha(t).toString()
  } catch (n) {
    return ""
  }
}
export { Z }
